/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Typography } from '@mui/material';

import { Namespaces } from '../../i18n';
import { HUModal2, HUModal2Props } from '../HUModal2/HUModal2';
import { useSimpleNotifyModalStyles } from './SimpleNotifyModal.styles';

type SimpleNotifyModalProps = Required<Pick<HUModal2Props, 'open'>> &
  Pick<HUModal2Props, 'onOk' | 'okButtonProps' | 'okButtonText' | 'disableEscapeKeyDown'> & {
    message?: string | React.ReactNode;
  };

export function SimpleNotifyModal(props: SimpleNotifyModalProps) {
  const { onOk, open, message, okButtonText, okButtonProps, disableEscapeKeyDown } = props;
  const classes = useSimpleNotifyModalStyles();
  const { t } = useTranslation([Namespaces.Common]);
  return (
    <HUModal2
      open={open}
      size="big"
      onOk={onOk}
      okButtonText={okButtonText ?? t(`${Namespaces.Common}:label.ok`)}
      okButtonProps={okButtonProps}
      onClose={onOk}
      disableRestoreFocus
      disableEscapeKeyDown={disableEscapeKeyDown}
    >
      <Typography variant="body1" classes={{ root: classes.modalText }} component="div">
        {message}
      </Typography>
    </HUModal2>
  );
}
